import React, { type ComponentType } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { ReactGadgetProps } from '@atlassian/jira-react-gadgets-common/src/types.tsx';
import { FilterResultsEditSkeleton } from '@atlassian/jira-skeletons/src/ui/dashboard/components/filter-results-edit.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { IssueTableGadgetData } from '../../../types.tsx';

const LazyFilterResultsGadgetEdit = lazyForPaint<
	ComponentType<ReactGadgetProps<IssueTableGadgetData>>
>(() => import(/* webpackChunkName: "async-react-filter-results-gadget-edit" */ './main'));

export const FilterResultsGadgetEdit = (
	props: ReactGadgetProps<IssueTableGadgetData>,
): React.JSX.Element => (
	<Placeholder name="filter-results-gadget-edit" fallback={<FilterResultsEditSkeleton />}>
		<LazyFilterResultsGadgetEdit {...props} />
	</Placeholder>
);

export const { preload } = LazyFilterResultsGadgetEdit;
